module.exports = __webpack_public_path__ + "img/favicon.912dbb4a.png";